import packageJson from "../package.json";
import type { components } from "@generated/openapi";
import type React from "react";

export const AXIOM_CLIENT_VERSION = packageJson.version;

export type User = components["schemas"]["User"];
export type UserDetails = components["schemas"]["UserDetails"];
export type Team = components["schemas"]["Team"];

export type GenericErrorResponse = components["schemas"]["GenericErrorResponse"];
export type GenericErrorWithSuggestionResponse = components["schemas"]["GenericErrorWithSuggestionResponse"];

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "wa-icon": React.DetailedHTMLProps;
    }
  }
}
